// Blog post registry — add new entries here whenever a new HTML file is dropped into /Blogs
// The `filename` must match the file placed in /public/blogs/

const blogPosts = [
  {
    id: 'post1-the-problem',
    slug: 'post1-the-problem',
    filename: 'post1-the-problem.html',
    title: "Pakistan Feeds 220 Million People on Farmland That's Falling Behind",
    subtitle:
      'The data behind the agricultural crisis — and why reinforcement learning is the right tool to start addressing it.',
    seriesTag: 'Post 1 of 5 · The Problem',
    series: 'CyclesGym-PK',
    tags: ['RL', 'AgriTech', 'Pakistan', 'Thesis'],
    readTime: '8 min read',
    date: 'May 2025',
  },
  {
    id: 'post2-architecture',
    slug: 'post2-architecture',
    filename: 'post2-architecture.html',
    title: 'CyclesGym-PK: Building a Pakistan Farm Inside a Simulator',
    subtitle:
      'The MDP formulation, state and action spaces, reward function, and how 30 years of Pakistani agricultural data was wired into an RL environment.',
    seriesTag: 'Post 2 of 5 · The Architecture',
    series: 'CyclesGym-PK',
    tags: ['RL', 'Simulation', 'MDP', 'AgriTech'],
    readTime: '10 min read',
    date: 'May 2025',
  },
  {
    id: 'post3-algorithm-showdown',
    slug: 'post3-algorithm-showdown',
    filename: 'post3-algorithm-showdown.html',
    title: 'PPO vs A2C vs DQN: Three Algorithms, One Pakistan Farm, 113 Experiments',
    subtitle:
      'A systematic comparison with ANOVA — revealing that algorithm choice accounts for 53.7% of all performance variance.',
    seriesTag: 'Post 3 of 5 · The Algorithm Battle',
    series: 'CyclesGym-PK',
    tags: ['PPO', 'A2C', 'DQN', 'Benchmarking'],
    readTime: '12 min read',
    date: 'May 2025',
  },
  {
    id: 'post4-hierarchical-rl',
    slug: 'post4-hierarchical-rl',
    filename: 'post4-hierarchical-rl.html',
    title: 'The Agent Discovered Crop Rotation On Its Own',
    subtitle:
      'Hierarchical Reinforcement Learning for joint crop planning and NPK fertilization — and the nitrogen fixation strategy that emerged without programming.',
    seriesTag: 'Post 4 of 5 · Hierarchical RL',
    series: 'CyclesGym-PK',
    tags: ['Hierarchical RL', 'Emergent Behaviour', 'Crop Rotation'],
    readTime: '11 min read',
    date: 'May 2025',
  },
  {
    id: 'post5-results-and-vision',
    slug: 'post5-results-and-vision',
    filename: 'post5-results-and-vision.html',
    title: 'Two Years. 113 Experiments. Here\'s What the Work Demonstrates.',
    subtitle:
      'Complete results across all environments, generalization to unseen weather, honest limitations, and the roadmap from simulation to real Pakistani farms.',
    seriesTag: 'Post 5 of 5 · The Full Picture',
    series: 'CyclesGym-PK',
    tags: ['Results', 'Generalization', 'Future Work'],
    readTime: '13 min read',
    date: 'May 2025',
  },
];

export default blogPosts;
